import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  TextField,
  Button,
  Select,
  Checkbox,
  Snackbar,
  Alert,
  FormGroup,
  FormControlLabel,
  Box,
  Grid,
  Typography,
  Paper,
  useTheme,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import LocationSelector from './LocationSelector'; 

import {
  saveProfileAction,
  updateProfileAction,
  getAllLocationsAction,
  searchUserNameAction,
  getUserPermissionAction,
  getUserAllPermissionAction
} from "../../../redux/actions/agencyActions";
import { useDispatch, useSelector } from "react-redux";
import { getAllLocationAction } from "../../../redux/actions/locationActions";
import { getRolesList } from "../../../redux/actions/roleActions";
import { getAllLocationGroupsAction } from '../../../redux/actions/locationGroupActions';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PhoneNumberField from "../../../common/PhoneNumberField";

export default function UserProfileForm({ user: propUser }) {
  const location = useLocation();
  const passedUser = location.state?.user;
  const user = propUser || passedUser;

  const theme = useTheme();
  const dispatch = useDispatch();
  const locationDetails = useSelector((state) => state?.location?.allLocation);
  const getAllRoles = useSelector((state) => state?.location?.getAllRolesList);
  const locationGroups = useSelector((state) => state?.locationGroup?.allLocationGroups || []);
  const get_all_location = useSelector((state) => state?.agency?.get_all_locations_list || []);
  const user_permission = useSelector((state) => state?.agency?.user_permission || []);
  const user_all_permission = useSelector((state) => state?.agency?.user_all_permission || []);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
 
  const [usernameCheckTimeout, setUsernameCheckTimeout] = useState(null);

  const [prefix, setPrefix] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [suffix, setSuffix] = useState("");

  const [emailAddress, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");
  const [userType, setUserType] = useState("");
  const [status, setStatus] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [homePhone, setHomePhone] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [workPhone, setWorkPhone] = useState("");

  const [defaultLocation, setDefaultLocation] = useState("");
  const [newRole, setRole] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [permissions, setPermissions] = useState({
    personalAuto: false,
    idCard: false,
    binders: false,
    homeowner: false,
  });

  const labelStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "19.6px",
    textAlign: "left",
    marginBottom: "8px",
  };

useEffect(() => {
  if (user) {
    const initialPermissions = {};
    user_all_permission.forEach((perm) => {
      const isSelected = user_permission.some((p) => p.name === perm.name);
      initialPermissions[perm.name] = isSelected;
    });
    setPermissions(initialPermissions);
  } else {
    const initialPermissions = {};
    user_permission.forEach((perm) => {
      initialPermissions[perm.name] = false;
    });
    setPermissions(initialPermissions);
  }
}, [user, user_all_permission, user_permission]);

  const createRequiredLabel = (text) => (
    <>
      {text}
      <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
    </>
  );

  const [errors, setErrors] = useState({});

  const [selectedLocationIds, setSelectedLocationIds] = useState([]);

  const handleLocationChange = (id) => {
    setSelectedLocationIds((prev) =>
      prev.includes(id)
        ? prev.filter((locId) => locId !== id)
        : [...prev, id]
    );
  };

 const handleSelectAll = (event) => {
  if (event.target.checked) {
    const allIds = get_all_location.map(loc => loc.locationId);
    setSelectedLocationIds(allIds);
  } else {
    setSelectedLocationIds([]);
  }
};

  let locationList = [];

  if (Array.isArray(locationDetails)) {
    locationList = locationDetails.map((location) => ({
      value: location.locationDescription,
      label: location.locationDescription,
    }));
  }

  let locationGroupList = [];
  if (Array.isArray(locationGroups)) {
    locationGroupList = locationGroups.map((location) => ({
      value: location.locationGroupName,
      label: location.locationGroupName,
    }));
  }

  const clearFieldError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors(prev => ({ ...prev, [fieldName]: "" }));
    }
  };

 const convertToE164 = (phoneNumber) => {
  if (!phoneNumber) return "";
  
  
  const cleaned = String(phoneNumber).replace(/\D/g, "");

  if (!cleaned) {
    return "";
  }

  
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `+${cleaned}`;
  }

  
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  }

  
  if (cleaned.length > 11) {
    const last10 = cleaned.slice(-10);
    return `+1${last10}`;
  }

  
  return `+1${cleaned}`;
};

  useEffect(() => {
    if (defaultLocation && !selectedLocationIds.includes(defaultLocation)) {
      setSelectedLocationIds([defaultLocation]);
    }
  }, [defaultLocation]);

  useEffect(() => {
    if(user){
      dispatch(getUserAllPermissionAction(user.id))
    }
  }, [user])

  useEffect(() => {
    dispatch(getUserPermissionAction())
  },[])

  useEffect(() => {
    dispatch(getAllLocationAction());
    dispatch(getRolesList());
    dispatch(getAllLocationGroupsAction());
    dispatch(getAllLocationsAction());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setPrefix(user.prefix || "");
      setFirstName(user.firstName || "");
      setMiddleName(user.middleName || "");
      setLastName(user.lastName || "");
      setSuffix(user.suffix || "");
      setEmail(user.email || "");
      setEmailConfirm(user.email || "");
      setUserType(user.userType || "");
      setStatus(user.status || "");
      setUserName(user.userName || "");
      setPassword(null);
      setConfirmPassword(null);
      setPhone(formatPhoneNumber(user.phone) || "");
      setHomePhone(formatPhoneNumber(user.homePhone) || "");
      setFaxNumber(formatPhoneNumber(user.faxNumber) || "");
      setWorkPhone(formatPhoneNumber(user.workPhone) || "");
     
      setDefaultLocation(user.defaultLocation?.id || "");
      setSelectedLocationIds(user.locations?.map(loc => loc.id) || []);
      setRole(user.newRole?.id || "");
    }
  }, [user]);


  const handlePermissionChange = (event) => {
    setPermissions((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCancelProfile = () => {
    navigate("/userlist")
  }

  const validatePasswords = (password, confirmPassword) => {
    const errors = {};
    if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    } else {
      errors.confirmPassword = "";
    }
    return errors;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!firstName.trim()) newErrors.firstName = "First Name is required";
    if (!lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!emailAddress.trim()) newErrors.emailAddress = "Email Address is required";
    if (!emailConfirm.trim()) newErrors.emailConfirm = "Confirm Email Address is required";
     if (!userName.trim()) newErrors.userName = "User Name is required";
    if (!userName.trim()) newErrors.userName = "User Name is required";
    if (!phone.trim()) newErrors.phone = "Phone is required";
    if (!defaultLocation) newErrors.defaultLocation = "Location is required";
    if (!newRole) newErrors.newRole = "Role is required";
    if (!newRole) newErrors.newRole = "Role is required";
    if (!status) newErrors.status = "Status is required";
    if (!userType) newErrors.userType = "User Type is required";

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailAddress && !emailPattern.test(emailAddress)) {
      newErrors.emailAddress = "Please enter a valid email address";
    }
    if (emailConfirm && !emailPattern.test(emailConfirm)) {
      newErrors.emailConfirm = "Please enter a valid email address";
    }
    if (emailAddress && emailConfirm && emailAddress !== emailConfirm) {
      newErrors.emailConfirm = "Email addresses do not match";
    }

    if (phone && phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!user) {
      if (!password) newErrors.password = "Password is required";
      if (!confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
      if (password && confirmPassword && password !== confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    } else {
      if (password || confirmPassword) {
        if (password !== confirmPassword) {
          newErrors.confirmPassword = "Passwords do not match";
        }
      }
    }
    return newErrors;
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrors({});

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formattedLocationIds = Array.isArray(selectedLocationIds)
      ? selectedLocationIds.map(loc => (typeof loc === 'object' ? loc.id : loc))
      : [];

    const flattenedPermissions = {};
    const selectedPermissionIds = [];

    const allPermissions = user ? user_all_permission : user_permission;


    Object.entries(permissions).forEach(([name, value]) => {
      const matched = allPermissions.find((p) => p.name === name);
      if (value && matched) {
        selectedPermissionIds.push(matched.id);
      }
    });

    const formData = {
      prefix,
      firstName: firstName.trim(),
      middleName: middleName.trim(),
      lastName: lastName.trim(),
      suffix,
      emailAddress: emailAddress.trim(),
      emailConfirm: emailConfirm.trim(),
      userType,
      status,
      userName: userName.trim(),
      password,
      confirmPassword,
      phone,
      homePhone,
      faxNumber,
      workPhone,
      cellPhone:null,
      defaultLocation,
      newRole,
      locationIds: formattedLocationIds,
      permissions: selectedPermissionIds,
      ...flattenedPermissions
    };
      const newformData = {
        ...formData,
        homePhone: formData.homePhone?.trim() ? convertToE164(formData.homePhone) : null,
        faxNumber: formData.faxNumber?.trim() ? convertToE164(formData.faxNumber) : null,
        workPhone: formData.workPhone?.trim() ? convertToE164(formData.workPhone) : null,
        phone: formData.phone?.trim() ? convertToE164(formData.phone) : null,
      }
    if (user) {
      if (!password && !confirmPassword) {
        delete formData.password;
        delete formData.confirmPassword;
      }

      if (emailAddress === user.email && emailConfirm === user.email) {
        delete formData.emailAddress;
        delete formData.emailConfirm;
      }

      dispatch(updateProfileAction({ ...newformData, id: user.id }, handleResponse));
    } else {
      dispatch(saveProfileAction(newformData, handleResponse));
    }
  };

  const handleResponse = (success, error) => {
  if (success) {
    setSnackbar({
      open: true,
      message: user ? 'User Profile Updated successfully' : 'User Profile created successfully',
      severity: 'success',
    });
    setTimeout(() => {
      navigate("/userlist");
    }, 1500);
  } else {
    if (error && error.errors && error.errors.length > 0) {
      const newErrors = {};

      error.errors.forEach(({ errorMessage, target }) => {
        const lowerTarget = target.toLowerCase();

        if (lowerTarget.includes("username")) {
          newErrors.userName = errorMessage;
        } else if (lowerTarget.includes("email")) {
          newErrors.emailAddress = errorMessage;
        } else if (lowerTarget.includes("password") && lowerTarget.includes("confirm")) {
          newErrors.confirmPassword = errorMessage;
        } else if (lowerTarget.includes("password")) {
          newErrors.password = errorMessage;
        } else {
          newErrors.general = errorMessage || "An error occurred. Please check your inputs.";
        }
      });

      setErrors(newErrors);
    } else {
      setSnackbar({
        open: true,
        message: "Something went wrong, please try again",
        severity: 'error',
      });
    }
  }
};
const formatPhoneNumber = (value) => {
  if (!value) return "";

  
  const phone = value.replace(/\D/g, "");
  
  
  const cleanPhone = (phone.length === 11 && phone.startsWith("1")) 
    ? phone.substring(1) 
    : phone;
  
  const phoneLength = cleanPhone.length;

  if (phoneLength < 4) {
    return cleanPhone;
  } else if (phoneLength < 7) {
    return `${cleanPhone.slice(0, 3)}-${cleanPhone.slice(3)}`;
  } else {
    return `${cleanPhone.slice(0, 3)}-${cleanPhone.slice(3, 6)}-${cleanPhone.slice(6, 10)}`;
  }
};

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        backgroundColor: theme.palette.background.default,
        padding:'24px 40px',
        boxSizing:'border-box',
        flexFlow:'column nowrap',
      }}
    >
       <Typography
          variant="h4"
          gutterBottom
        >
          {user ? "Edit User Profile" : "Add New User"}
        </Typography>
      <Paper
        elevation={3}
        sx={{
          width: "calc(100% - 32px)",          
          padding: theme.spacing(3),
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
           <Grid item xs={12} sm={6} md={1.6}>
              <Typography variant="body1" sx={labelStyle}>
                Prefix
              </Typography>
              <Select
                native
                id="prefix"
                name="prefix"
                fullWidth
                value={prefix}
                onChange={(e) => setPrefix(e.target.value)}
                inputProps={{
                  id: 'prefix-native',
                }}
              >
                <option value="">Select a prefix</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Dr.">Dr.</option>
              </Select>
            </Grid>

            <Grid item xs={12} sm={6} md={2.92}>
              <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("First Name")}
              </Typography>
              <TextField
                required
                fullWidth
                value={firstName}
                onChange={(e) => {
                  if (/^[A-Za-z\s]*$/.test(e.target.value) || e.target.value === "") {
                    setFirstName(e.target.value);
                    clearFieldError('firstName');
                  }
                }}
                id="firstname"
                name="firstName"
                error={!!errors.firstName}
                helperText={errors.firstName}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.93}>
              <Typography variant="body1" sx={labelStyle}>
                Middle Name
              </Typography>
              <TextField
                fullWidth
                value={middleName}
                onChange={(e) => {
                  if (/^[A-Za-z\s]*$/.test(e.target.value) || e.target.value === "") {
                    setMiddleName(e.target.value);
                  }
                }}
                id="middlename"
                name="middleName"
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.93}>
              <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("Last Name")}
              </Typography>
              <TextField
                required
                fullWidth
                value={lastName}
                onChange={(e) => {
                  if (/^[A-Za-z\s]*$/.test(e.target.value) || e.target.value === "") {
                    setLastName(e.target.value);
                    clearFieldError('lastName');
                  }
                }}
                id="lastname"
                name="lastName"
                error={!!errors.lastName}
                helperText={errors.lastName}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={1.6}>
              <Typography variant="body1" sx={labelStyle}>
                Suffix
              </Typography>
              <Select
                native
                id="suffix"
                name="suffix"
                fullWidth
                value={suffix}
                onChange={(e) => setSuffix(e.target.value)}
                inputProps={{
                  id: 'suffix-native',
                }}
              >
                <option value="">Select a suffix</option>
                <option value="Jr.">Jr.</option>
                <option value="Sr.">Sr.</option>
                <option value="II">II</option>
                <option value="III">III</option>
              </Select>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
               <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("User Type")}
              </Typography>
              <Select
                    native
                    id="userType"
                    name="userType"
                    fullWidth
                    value={userType}
                    onChange={(e) => {
                        setUserType(e.target.value);
                        clearFieldError('userType');
                      }}
                    error={!!errors.userType}
                  >
                <option value="">Select a user type</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </Select>
            {errors.userType && (
              <Typography variant="caption" color="error">
                {errors.userType}
              </Typography>
            )}
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("Email Address")}
              </Typography>
              <TextField
                required
                fullWidth
                autoComplete="off"
                value={emailAddress}
                onChange={(e) => {
                  const email = e.target.value;
                  setEmail(email);
                  clearFieldError('emailAddress');
                }}
                id="emailaddress"
                name="emailAddress"
                error={!!errors.emailAddress}
                helperText={errors.emailAddress}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("Confirm Email")}
              </Typography>
              <TextField
                required
                fullWidth
                autoComplete="off"
                value={emailConfirm}
                onChange={(e) => {
                  setEmailConfirm(e.target.value);
                  clearFieldError('emailConfirm');
                }}
                id="emailconfirm"
                name="emailConfirm"
                error={!!errors.emailConfirm}
                helperText={errors.emailConfirm}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={labelStyle}>
                {createRequiredLabel("User Name")}
              </Typography>
              <TextField
                  required
                  autoComplete="off"
                  fullWidth
                  value={userName}
                  id="username"
                  error={!!errors.userName}
                  helperText={errors.userName}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[A-Za-z0-9@\s]*$/.test(value) || value === "") {
                      setUserName(value);
                      clearFieldError("userName");

                     
                      if (usernameCheckTimeout) clearTimeout(usernameCheckTimeout);
                      const timeout = setTimeout(() => {
                        if (value.trim().length > 2) {
                         
                          dispatch(searchUserNameAction(value.trim(), (response) => {
                            if (response.isTaken) {
                              setErrors((prev) => ({
                                ...prev,
                                userName: "This username already taken. Please choose another.",
                              }));
                            } else {
                              setErrors((prev) => ({
                                ...prev,
                                userName: "",
                              }));
                            }
                           
                          }));
                        }
                      }, 500);
                      setUsernameCheckTimeout(timeout);
                    }
                  }}
                  inputProps={{ maxLength: 30 }}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={labelStyle}>
                {!user ? createRequiredLabel("Password") : "Password"}
              </Typography>
              <TextField
                fullWidth
                autoComplete="off"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  const newPassword = e.target.value;
                  setPassword(newPassword);
                  clearFieldError('password');
                  const updatedErrors = validatePasswords(newPassword, confirmPassword);
                  if (updatedErrors.confirmPassword === "") {
                    clearFieldError('confirmPassword');
                  }
                }}
                id="password"
                name="password"
                error={!!errors.password}
                helperText={errors.password}
                inputProps={{ maxLength: 30 }}
                placeholder={user ? "•".repeat(8) : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handlePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={labelStyle}>
                {!user ? createRequiredLabel("Confirm Password") : "Confirm Password"}
              </Typography>
              <TextField
                fullWidth
                autoComplete="off"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => {
                  const newConfirmPassword = e.target.value;
                  setConfirmPassword(newConfirmPassword);
                  clearFieldError('confirmPassword');
                  const updatedErrors = validatePasswords(password, newConfirmPassword);
                  if (updatedErrors.confirmPassword === "") {
                    clearFieldError('confirmPassword');
                  }
                }}
                id="confirmPassword"
                name="confirmPassword"
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                inputProps={{ maxLength: 30 }}
                placeholder={user ? "•".repeat(8) : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle confirm password visibility"
                        onClick={handleConfirmPasswordVisibility}
                        edge="end"
                      >
                        {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
             
              <PhoneNumberField
                required
                fullWidth
                autoComplete="off"
                value={phone}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[\d-]*$/.test(value)) {
                    setPhone(formatPhoneNumber(value));
                    clearFieldError('phone');
                  }
                }}
                id="phone"
                name="phone"
                inputProps={{
                  maxLength: 12,
                }}
                error={!!errors.phone}
                helperText={errors.phone}
                 label="Phone"
                  
                   labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
          
              <PhoneNumberField
                fullWidth
                autoComplete="off"
                value={homePhone}
                onChange={(e) => setHomePhone(e.target.value)}
                id="homephone"
                name="homePhone"
                inputProps={{
                  maxLength: 12,
                }}
                 label="Home Phone"
                   required={false}
                   labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <PhoneNumberField
                fullWidth
                autoComplete="off"
                value={faxNumber}
                onChange={(e) => setFaxNumber(e.target.value)}
                id="faxnumber"
                name="faxNumber"
                inputProps={{
                  maxLength: 12,
                }}
                label="Fax Number"
                required={false}
                labelStyle={{ fontSize: 14, fontWeight: 500, mb: 1 }}
              />
            </Grid>

          <Grid item xs={12} sm={6} md={3}>
           
            <PhoneNumberField
              fullWidth
              value={workPhone}
              onChange={(e) => setWorkPhone(e.target.value)}
              id="workphone"
              name="workPhone"
              inputProps={{
                maxLength: 12,
              }}
               label=" Work Phone"
                   required={false}
                   labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}
            />
          </Grid>


          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body1" sx={labelStyle}>
              {createRequiredLabel("Default Location")}
            </Typography>
            <Select
                native
                id="defaultlocation"
                name="defaultLocation"
                fullWidth
                value={defaultLocation}
                onChange={(e) => {
                  const selectedId = parseInt(e.target.value);
                  setDefaultLocation(selectedId);
                  setSelectedLocationIds((prev) =>
                    prev.includes(selectedId) ? prev : [...prev, selectedId]
                  );
                  clearFieldError('defaultLocation');
                }}
                error={!!errors.defaultLocation}
                required
              inputProps={{
                  id: 'defaultlocation-native',
                }}
              >
              <option value="">Select a location</option>

              {get_all_location
                .filter((loc) => loc && loc.locationId && loc.locationDescription)
                .map((loc, i) => (
                  <option key={`loc-${i}`} value={loc.locationId}>
                    {loc.locationDescription}
                  </option>
                ))}

              {locationGroupList
                .filter((group) => group && group.value && group.label)
                .map((group, i) => (
                  <option key={`group-${i}`} value={group.value}>
                    {group.label}
                  </option>
                ))}
            </Select>
            {errors.defaultLocation && (
              <Typography variant="caption" color="error" sx={{ ml: 2 }}>
                {errors.defaultLocation}
              </Typography>
            )}
          </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="body1" sx={labelStyle}>
          {createRequiredLabel("Role")}
        </Typography>
        <Select
            native
            id="role"
            name="newRole"
            fullWidth
            value={newRole}
            onChange={(e) => {
              setRole(e.target.value);
              clearFieldError('newRole');
            }}
            error={!!errors.newRole}
          >
            <option value="">Select a Role</option>
            {getAllRoles
              .filter((role) => !role.isSuperUser)
              .map((role) => (
                <option key={role.id} value={role.id}>
                  {role.displayName}
                </option>
              ))}
          </Select>
          {errors.newRole && (
            <Typography variant="caption" color="error" sx={{ ml: '15px' }}>
              {errors.newRole}
            </Typography>
          )}
        </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="body1" sx={labelStyle}>
          {createRequiredLabel("Status")}
        </Typography>
       <Select
          native
          id="status"
          name="status"
          fullWidth
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            clearFieldError('status');
          }}
          error={!!errors.status}
        >
          <option value="">Select status</option>
          <option value="ACTIVE">Active</option>
          <option value="DEACTIVATED">Deactivated</option>
          <option value="SUSPENDED">Suspended</option>
        </Select>
        {errors.status && (
          <Typography variant="caption" color="error" sx={{ ml: '15px' }}>
            {errors.status}
          </Typography>
        )}
      </Grid>

      <Button
        onClick={handleOpenDialog}
        sx={{
          backgroundColor: "white",
          width: 330,
          height: 57,
          marginTop: 6.4,
          marginLeft: 3.4, 
        }}
        variant="outlined"
      >
        Add More Locations
      </Button>

      <Dialog
        maxWidth="lg"
        fullWidth
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseDialog(event, reason);
        }}
      >
        <DialogTitle
        >
          Multiple Locations
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, px: 1, pt: 2 }}>
            <TextField
              placeholder="Search Location"
              variant="outlined"
              fullWidth
              size="small"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              sx={{
              width: 300,
              '& .MuiInputBase-root': {
                height: 50,
              },
            }}
            />
            <Button
              onClick={() => setSearchQuery(searchInput)}
              variant="outlined"
              size="large"
            >
              Search
            </Button>

            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                  setSearchInput("");
                  setSearchQuery("");
                }}
              >
                Reset
              </Button>
            </Box>

            <Box sx={{ p: 0 }}>
              <LocationSelector
                get_all_location={get_all_location}
                selectedLocationIds={selectedLocationIds}
                defaultLocation={defaultLocation}
                handleSelectAll={handleSelectAll}
                handleLocationChange={handleLocationChange}
                searchQuery={searchQuery}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 4,
                mr: 2,
              }}
            >
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                size="large"
              >
                Save
              </Button>
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                size="large"
              >
                Cancel
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Grid item xs={12}>
          <Typography id="permissions" variant="h6" sx={{ marginY: 2 }}>

          </Typography>
          <FormGroup row>
            {(user ? user_all_permission : user_permission).map((perm) => (
              <FormControlLabel
                key={perm.id || perm.name}
                control={
                  <Checkbox
                    checked={permissions?.[perm.name] || false}
                    onChange={handlePermissionChange}
                    name={perm.name}
                  />
                }
                label={perm.name}
              />
            ))}
          </FormGroup>
        </Grid>
      </Grid>

      <Grid
        item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            marginTop: 4,
          }}
        >
          <Button
            id="cancelbutton"
            variant="outlined"
            size="large"
            onClick={handleCancelProfile}
          >
            Cancel
          </Button>

          <Button
            id="submitbutton"
            type="submit"
            variant="contained"
            onClick={handleSubmit}
            size="large"
          >
            {user ? "Update" : "Save"}
          </Button>
        </Grid>
      </form>
    </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={1000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}